import actionType from '../actions/ctripDirect/actionType';

const initialState: any = {
  // 携程总览
  getCtripOverviewLoading: false,
  overviewInfos: {},

  // 同步日志
  getSyncRecordLoading: false,
  syncRecordSearchParam: { pageNum: 1, pageSize: 50 },
  syncRecordSearchRes: {
    list: [],
    total: 0,
  },

  // 房型匹配
  getRoomMatchListLoading: false,
  roomMatchList: [],
  dayUseList: [],
  timeRentList: [],

  getNotMatchedListLoading: false,
  notMatchedList: [],

  // 房量管理
  dateRangeOption: [],
  dateRangeIndex: 0,

  getRoomQuantityLoading: false,
  dayRoomList: [],
  hourRoomList: [],

  xcHotelInfoList: [],
  xczlHotelInfoLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.CLEAR_DATA:
      return {
        ...state,
        ...action.payload,
      };
    // 携程总览
    case actionType.SET_CTRIP_OVERVIEW_INFOS:
      return {
        ...state,
        ...action.payload,
      };
    // 日志同步
    case actionType.UPDATE_SEARCH_RES:
      return {
        ...state,
        syncRecordSearchRes: {
          ...state.syncRecordSearchRes,
          ...action.payload,
        },
      };
    case actionType.UPDATE_SEARCH_PARAM:
      return {
        ...state,
        syncRecordSearchParam: {
          ...state.syncRecordSearchParam,
          [action.payload.field]: action.payload.value,
        },
      };
    // 房型匹配
    case actionType.SET_ROOM_TYPE_MATCH_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SET_NOT_MATCHED_ROOM_LIST:
      return {
        ...state,
        ...action.payload,
      };

    // 房量管理
    case actionType.SET_CTRIP_DATE_RANGE_OPTION:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SET_CTRIP_DATE_RANGE_INDEX:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SET_CTRIP_ROOM_QUANTITY_LIST:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return {
        ...state,
        ...action.payload,
      };
  }
};
